import React from 'react'
import { useMapEvents, Marker, Popup } from 'react-leaflet'
import ReactDOMServer from 'react-dom/server'
import L from 'leaflet'
import { Location } from '../../../../types/types'

interface LocationMarkerProps {
  location: Location | null
  handleClick: (lat: number, lng: number) => void
}
function LocationMarker({ location, handleClick }: LocationMarkerProps) {
  useMapEvents({
    click(e) {
      handleClick(e.latlng.lat, e.latlng.lng)
    },
  })

  const customMarkerIcon = L.divIcon({
    html: ReactDOMServer.renderToString(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#FF0000"
      >
        <path d="M12,0C7.309,0,3.273,3.582,3.273,8.004c0,4.422,8.727,15.996,8.727,15.996S20.727,12.426,20.727,8.004C20.727,3.582,16.691,0,12,0z M12,11.996c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C16,10.205,14.209,11.996,12,11.996z" />
      </svg>
    ),
    className: 'custom-marker-icon',
  })

  return (
    <React.Fragment>
      {location && (
        <Marker
          position={[location.lat, location.long]}
          icon={customMarkerIcon}
        >
          <Popup>Chosen country: {location.country} </Popup>
        </Marker>
      )}
    </React.Fragment>
  )
}

export default LocationMarker
